import { FunctionComponent } from "react";
import { tracker } from "@pjs/analytics";
import { Hyperlink, Icon, privacyIcon } from "@pjs/core-ui";
import { apiConfig } from "../../ApiConfig";
import { userUiI18n } from "../i18n/UserUiI18n.const";
import { ISettingsSidebarProps } from "./interfaces/ISettingsSidebarProps";
import { View } from "./enums/View";
import "./styles/settings-sidebar.css";

export const SettingsSidebar: FunctionComponent<ISettingsSidebarProps> = (props) => {
    const handleSetView = (newView: View): void => {
        tracker.trackEvent("Account Settings", "Select view", `${newView} view selected`);
        props.setView(newView);
    };

    const hideSidebar = props.hideSidebar ? "uui-settings-sidebar--hide-sidebar" : "";
    return (
        <aside
            data-hook="settings-sidebar"
            className={`uui-settings-sidebar ${hideSidebar}`}
            aria-label={userUiI18n.getString("settings_sidebar.a11y.buttons.group")}>
            <nav>
                {props.availableViews.map((subView, index) => {
                    const key = `${subView.length}-${index}`;

                    return (
                        <div className="uui-settings-sidebar__button-container" key={key}>
                            {subView.map((view) => {
                                const id = view.id;
                                const isButtonActive = props.activeView !== null ? id === props.activeView.id : false;

                                const selected = isButtonActive ? "uui-settings-sidebar__button--selected" : "";
                                const ariaCurrent = isButtonActive ? "page" : undefined;
                                return (
                                    <button
                                        key={id}
                                        className={`uui-settings-sidebar__button ${selected}`}
                                        data-hook={`account-settings-navigation-${id}-button`}
                                        onClick={() => handleSetView(id)}
                                        aria-current={ariaCurrent}>
                                        <Icon className="uui-settings-sidebar__icon" source={view.navigation.icon} />
                                        {view.navigation.label}
                                    </button>
                                );
                            })}
                        </div>
                    );
                })}

                <Hyperlink
                    data-hook="account-settings-policy-link"
                    className="uui-settings-sidebar__button uui-settings-sidebar__link"
                    aria-label={userUiI18n.getString("settings_sidebar.a11y.buttons.policy")}
                    href={apiConfig.policyLink()}
                    onClick={() => tracker.trackEvent("Account Settings", "Clicked GDPR button")}
                    target="_blank"
                    rel="noopener noreferrer">
                    <Icon className="uui-settings-sidebar__icon" source={privacyIcon} />
                    {userUiI18n.getString("settings_sidebar.buttons.policy")}
                </Hyperlink>
                <Hyperlink
                    data-hook="account-settings-terms-link"
                    className="uui-settings-sidebar__button uui-settings-sidebar__link"
                    aria-label={userUiI18n.getString("settings_sidebar.a11y.buttons.terms")}
                    href={apiConfig.termsLink()}
                    onClick={() => tracker.trackEvent("Account Settings", "Clicked terms and conditions button")}
                    target="_blank"
                    rel="noopener noreferrer">
                    <Icon className="uui-settings-sidebar__icon" source={privacyIcon} />
                    {userUiI18n.getString("settings_sidebar.buttons.terms")}
                </Hyperlink>
            </nav>
        </aside>
    );
};
